import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import RelatorioService from 'services/relatorio-service';
import RepresentadaService from 'services/representada-service';
import PedidoService from 'services/pedido-service';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWineBottle, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import lib from '../../../helpers/lib';
import './styles.scss';
import '../styles.scss';
import Skeleton from 'react-loading-skeleton';

export default function FaturamentoPorcentagemCategoria() {
  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();

  const [isLoading, setIsLoading] = React.useState(true);

  const [representadas, setRepresentadas] = React.useState([]);
  const [vendedores, setVendedores] = React.useState([]);
  const [categorias, setCategorias] = React.useState([]);
  const [totalCategorias, setTotalCategorias] = React.useState([]);

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    mes: m + 1,
    ano: y
  });

  useEffect(() => {
    (async () => {
      getRepresentadas();
      getSelectListVendedor();
    })();
  }, []);

  useEffect(() => {
    if (loadedRepresentadas && loadedVendedores) {
      getFaturamentoPorcentagemCategoria();
    }
  }, [loadedRepresentadas, loadedVendedores]);

  // useEffect(() => {
  //   (async () => {
  //     if (categorias.length > 0) {
  //       let catTotal = {
  //         nomeCategoria: ' ',
  //         atingidoMesAnterior: +categorias
  //           .reduce((acc, item) => acc + item.atingidoMesAnterior, 0)
  //           .toFixed(2),
  //         atingidoFaturado: +categorias
  //           .reduce((acc, item) => acc + item.atingidoFaturado, 0)
  //           .toFixed(2),
  //         atingidoMeta: +categorias.reduce((acc, item) => acc + item.atingidoMeta, 0).toFixed(2),
  //         porcentagemAtingidoFaturado: null
  //       };

  //       // catTotal.diferencaMetaPraFaturado =
  //       //   catTotal.atingidoMeta != 0
  //       //     ? +((catTotal.atingidoFaturado / catTotal.atingidoMeta) * 100).toFixed(2)
  //       //     : 0;

  //       setTotalCategorias([catTotal]);
  //     }
  //   })();
  // }, [categorias]);

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();
    if (response?.data) {
      setRepresentadas(response?.data?.data[0]?.options);

      setFilter((prevFilter) => ({
        ...prevFilter,
        representadaId: response?.data?.data[0]?.options[0]?.value
      }));
    }
    setLoadedRepresentadas(true);
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();
    if (vendedores.data) {
      setVendedores(vendedores.data.data);

      if (vendedores.data.data.length == 1) {
        setFilter((prevFilter) => ({ ...prevFilter, vendedorId: vendedores.data.data[0].value }));
      }
    }
    setLoadedVendedores(true);
  }

  async function getFaturamentoPorcentagemCategoria() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getFaturamentoPorcentagemCategoria(filter);

    if (resultStatus.data) {
      setCategorias(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getExtratoPorcentagemCategoria() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoPorcentagemCategoria(filter);

    if (response?.data) {
      let fileName = `faturamento_porcentagem_categoria_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <Layout>
      <PageTitleCard title="Categoria" icon={<FontAwesomeIcon icon={faWineBottle} />} />

      <div className="background-relatorio">
        <div className="row filter-bar2 mb-5">
          <div className="col-lg-2" disabled>
            <label>Representada</label>
            <Select
              isClearable={false}
              // clearValue={() => {
              //   setFilter({ ...filter, representadaId: null });
              // }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={representadas}
              value={representadas?.find((x) => x.value === filter.representadaId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, representadaId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Vendedor</label>
            <Select
              isClearable={vendedores?.length > 1}
              clearValue={() => {
                setFilter({ ...filter, vendedorId: null });
              }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores?.find((x) => x.value === filter.vendedorId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, vendedorId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Mês</label>
            <Select
              className="select-form-control"
              value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
              options={lib.selectListMeses}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, mes: item.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Ano</label>
            <Select
              className="select-form-control"
              value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
              options={lib.selectListAnos}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, ano: item.value });
              }}
            />
          </div>

          <div className="col row">
            <div className="col-6"></div>

            <div className="col-3 align-content-end">
              {/* Botão Exportar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                  });
                  getExtratoPorcentagemCategoria();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFileExcel} /> Exportar
              </button>
            </div>

            <div className="col-3 align-content-end">
              {/* Botão Filtrar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                    //pageNumber: 1
                  });
                  getFaturamentoPorcentagemCategoria();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFilter} /> Filtrar
              </button>
            </div>
          </div>
        </div>

        {/* Lista Representadas ----------------------------------------------------------------- */}
        <div
          className="table-responsive table-historico mt-4"
          onCopy={(e) => lib.parseCopiedText(e)}
        >
          {!isLoading && categorias ? (
            <Table striped bordered hover width="100%" className="table-relatorio">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th style={{ textAlign: 'center' }}>Fat Mês Anterior</th>
                  <th style={{ textAlign: 'center' }}>Faturado</th>
                  {/* <th>Valor Faturado</th> */}
                  <th style={{ textAlign: 'center' }}>Objetivo</th>
                  <th style={{ textAlign: 'center' }}>Diferença</th>
                </tr>
              </thead>
              <tbody>
                {categorias.length > 0 ? (
                  ([...categorias] || [])?.map((item, index) => (
                    <tr key={index} className={index >= categorias.length ? 'fw-600' : ''}>
                      <td>{item.nomeCategoria}</td>
                      <td style={{ textAlign: 'center' }}>
                        <span>{lib.formatToNumeric(item.atingidoMesAnterior, 2, true)}%</span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.atingidoFaturado != null ? (
                          <span>{lib.formatToNumeric(item.atingidoFaturado, 2, true)}%</span>
                        ) : null}
                      </td>
                      {/* <td>{item.valorFaturado != null ? <span>{item.valorFaturado}</span> : null}</td> */}
                      <td style={{ textAlign: 'center' }}>
                        {item.atingidoMeta != null ? (
                          <span>{lib.formatToNumeric(item.atingidoMeta, 2, true)}%</span>
                        ) : (
                          0
                        )}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.diferencaMetaPraFaturado != null ? (
                          <span
                            className={item.diferencaMetaPraFaturado >= 0 ? 'txt-green' : 'txt-red'}
                          >
                            {lib.formatToNumeric(item.diferencaMetaPraFaturado, 2, true)}%
                          </span>
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Skeleton count={10} />
          )}
        </div>
      </div>
    </Layout>
  );
}
